import { render } from "./DeleteFromCompany.vue?vue&type=template&id=cf619ae2"
import script from "./DeleteFromCompany.vue?vue&type=script&lang=js"
export * from "./DeleteFromCompany.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__